import { useState } from "react";
import PiChatTypingSolid from "@markeroo/icons/src/solid/communication/PiChatTypingSolid";
import { buttonVariants } from "@markeroo/theme";
import { zIndex } from "@/styles/variants";
import { ui } from "@/strings";
import { FeedbackModal } from "./FeedbackModal";

export function FeedbackButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className={`${buttonVariants.primary} fixed bottom-6 right-6 hidden lg:flex gap-1.5 rounded-full shadow-lg hover:shadow-xl`}
        style={{ zIndex: zIndex.toast }}
        aria-label={ui.actions.feedback}
      >
        <PiChatTypingSolid size={20} />
        <span className="text-sm font-semibold">{ui.actions.feedback}</span>
      </button>
      <FeedbackModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}
